import { makeStyles, Container, Typography } from '@material-ui/core';


let useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
    },
    container: {
        marginTop: 300
    }
}));

let Homepage = () => {
    let classes = useStyles();

    return (
        <div className={classes.root}>
            <Container
                maxWidth="md"
                className={classes.container}
            >
                <Typography align="center" variant="h2">
                    Welcome to Admin Warranty
                </Typography>
                <Typography align="center" variant="subtitle2">
                    Use this website to check and update Warranty Registrations
                </Typography>
            </Container>
        </div>
    )
}

export default Homepage;